import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Col, Row, Card, Table, Button } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faPlus } from '@fortawesome/free-solid-svg-icons'
import { confirmNumberTicket, getPowerResults } from '../../../../controller/api/gameResult'
import RewardCalcStatusCell, { RewardCalcActionsCell } from '../../../../components/RewardCalcStatusCell'
import { useCookies } from 'react-cookie'
import { calculatePage, convertToVietnamTime } from '../../../../helper/helper'
import Pagination from '../../../../components/Pagination'
import CalculateRewardPopup from '../sub-screen/calculate-reward-popup/CalculateRewardPopup'
import ResultEditPopup from '../sub-screen/result-edit-popup/ResultEditPopup'
import ResultAddPopup from '../sub-screen/result-add-popup/ResultAddPopup'
import { useLocation } from 'react-router-dom'
import { parseQuerySimple } from '../../../../helper/urlHelper'

const TableRow = (props) => {
  const { gamePeriod, result, status, totalTickets, totalRewaredTickets, totalUnRewardTickets, onCalculateRewardPress, onEditResultPress, onAddResultPress, onConfirmNumberTicket } = props;
  const hasResult = Boolean(result && result.length > 0)

  const resultArray = result.length > 0 ? result[0].split(' ') : []

  const specialNumber = resultArray.splice(-1)

  const baseArray = resultArray.join(' ')

  const notHaveResultYet = <td><span className="text-warning me-2">Chưa có kết quả</span><Button variant="light" size="sm" className="border" onClick={() => onAddResultPress(gamePeriod)}><FontAwesomeIcon icon={faPlus} className="me-2" />Nhập kết quả</Button></td>

  const cannotGetResult = <td className="text-danger">{"Không lấy được kết quả"}</td>

  let resultTd = notHaveResultYet

  if (hasResult) {
    resultTd = <td>
      <div className="d-flex align-items-center gap-2">
        <h5 className="mb-0"><span className="text-primary">{baseArray}</span> <span className="text-warning">{specialNumber}</span></h5>
        <Button variant="light" size="sm" className="border px-2" onClick={() => onEditResultPress(gamePeriod, result)} title="Sửa kết quả" aria-label="Sửa kết quả"><FontAwesomeIcon icon={faEdit} /></Button>
      </div>
    </td>
  } else {
    if (status === 1) {
      resultTd = cannotGetResult
    }
  }

  return (
    <tr>
      <RewardCalcActionsCell
        gameId="power"
        gamePeriodId={gamePeriod.id}
        status={status}
        totalTickets={totalTickets}
        totalRewaredTickets={totalRewaredTickets}
        totalUnRewardTickets={totalUnRewardTickets}
        onConfirmNumberTicket={onConfirmNumberTicket}
        onCalculateReward={hasResult ? () => onCalculateRewardPress(gamePeriod) : null}
      />
      <td>
        <b>{'#' + gamePeriod.name || ""}</b><br />
        {gamePeriod.resultDate}<br />
        <span className="text-info">{convertToVietnamTime(gamePeriod.resultTime)}</span>
      </td>
      <td>
        Tổng số vé: <b className='text-info'>{totalRewaredTickets + totalUnRewardTickets}</b><br />
        Trúng thưởng: <b className='text-success'>{totalRewaredTickets}</b><br />
        Không trúng thưởng: <b className='text-danger'>{totalUnRewardTickets}</b><br />
      </td>
      {resultTd}
      <RewardCalcStatusCell
        status={status}
        totalTickets={totalTickets}
        totalRewaredTickets={totalRewaredTickets}
        totalUnRewardTickets={totalUnRewardTickets}
      />
    </tr>
  );
};

export const PowerTable = () => {

  const location = useLocation()
  const period = parseQuerySimple(location.search).period || ''

  const [data, setData] = useState({})

  const [page, setPage] = useState(0)

  const [loaded, setLoaded] = useState(false)

  const [cookies] = useCookies(['lottmekong'])

  const getAllFunc = useCallback(async () => {
    const response = await getPowerResults(cookies.lottmekong, page, period)

    if (response) {
      const res = {
        list: response.data,
        total: response.total,
        totalPage: calculatePage(response.total)
      }

      setData(res || {})
      setLoaded(true)
    }
  }, [cookies.lottmekong, page, period])

  const onConfirmNumberTicket = async (periodId, numberTicket) => {
    const response = await confirmNumberTicket(cookies.lottmekong, periodId, numberTicket)

    if (response) {
      const _newData = JSON.parse(JSON.stringify(data))

      _newData.list = _newData.list.map(it => {
        if (it.gamePeriod.id === periodId) {
          it.totalTickets = numberTicket
        }
        return {
          ...it
        }
      })
      setData(_newData)
    }
  }

  const [modalCalculateRewardShow, setModalCalculateRewardShow] = useState(false)

  const [modalEditResultShow, setModalEditResultShow] = useState(false)

  const [modalAddResultShow, setModalAddResultShow] = useState(false)

  const gamePeriodRef = useRef(null)
  const resultRef = useRef(null)

  useEffect(() => {
    getAllFunc()
  }, [getAllFunc])

  const onShowCalculateRewardPopupPress = (gamePeriod) => {
    gamePeriodRef.current = gamePeriod
    setModalCalculateRewardShow(true)
  }

  const onShowEditResultPopupPress = (gamePeriod, result) => {
    gamePeriodRef.current = gamePeriod
    resultRef.current = result
    setModalEditResultShow(true)
  }

  const onShowAddResultPopupPress = (gamePeriod) => {
    gamePeriodRef.current = gamePeriod
    setModalAddResultShow(true)
  }

  const onHideCalculateRewardPopupPress = (totalRewardTicket, totalUnrewardTicket, callback) => {
    const _newData = JSON.parse(JSON.stringify(data))

    _newData.list = _newData.list.map(it => {
      if (it.gamePeriod.id === gamePeriodRef.current.id) {
        it.totalRewaredTickets += totalRewardTicket
        it.totalUnRewardTickets += totalUnrewardTicket
      }
      return {
        ...it
      }
    })
    setData(_newData)

    gamePeriodRef.current = null

    callback()

    setModalCalculateRewardShow(false)
  }

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header>
          <Row className="align-items-center">
            <Col>
              <h5>Power 6/55 ({data.total})</h5>
            </Col>
          </Row>
        </Card.Header>
        <Table responsive className="align-items-center table-flush">
          <thead className="thead-light">
            <tr>
              <th scope="col">Tính thưởng</th>
              <th scope="col">Kỳ quay số</th>
              <th scope="col">Thống kê vé</th>
              <th scope="col">Kết quả quay số</th>
              <th scope="col">Trạng thái</th>
            </tr>
          </thead>
          <tbody>
            {data.list && data.list.map((pv, index) => <TableRow onConfirmNumberTicket={onConfirmNumberTicket} onCalculateRewardPress={onShowCalculateRewardPopupPress} onEditResultPress={onShowEditResultPopupPress} onAddResultPress={onShowAddResultPopupPress} rIndex={index} key={`result-status-${index}`} {...pv} />)}
          </tbody>
        </Table>
        <Card.Footer className='flex-row'>
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={data.totalPage}
                currentPage={page}
                onPageChange={(i) => {
                  setLoaded(false)
                  setPage(i)
                }}
              />
            </Col>
            <Col>
              {loaded ? '' : 'Đang tải dữ liệu'}
            </Col>
          </Row>
        </Card.Footer>
      </Card>
      <CalculateRewardPopup
        show={modalCalculateRewardShow}
        period={gamePeriodRef.current}
        onHide={onHideCalculateRewardPopupPress}
      />
      <ResultEditPopup
        show={modalEditResultShow}
        period={gamePeriodRef.current}
        result={resultRef.current}
        onHide={() => setModalEditResultShow(false)}
      />
      <ResultAddPopup
        show={modalAddResultShow}
        period={gamePeriodRef.current}
        onHide={() => setModalAddResultShow(false)}
      />
    </>
  );
};
